<app-base-modal dialogTitle="Add incident" (closeEvent)="onCancel()">
  <div class="modal-hint">
    Provide a URL to start automated data collection. Processing runs overnight, and the incident will be available the
    next day.
  </div>

  <form [formGroup]="formGroup">
    <div>
      <mat-form-field appearance="outline" floatLabel="always" style="width: 100%">
        <mat-label>Incident URL</mat-label>
        <textarea matInput cdkTextareaAutosize formControlName="url" cdkAutosizeMinRows="3" cdkAutosizeMaxRows="10">
        </textarea>
        @if (formGroup.get('url')?.hasError('required')) {
          <mat-error> URL is required </mat-error>
        }
        @if (formGroup.get('url')?.hasError('invalidSyntaxUrl')) {
          <mat-error> Enter a valid URL </mat-error>
        }
      </mat-form-field>
    </div>
  </form>

  <!-- This is projected by the ng-content of the app-base-modal -->
  <div panel-footer>
    <button mat-flat-button class="button-link" (click)="onCancel()">Cancel</button>
    <button mat-flat-button class="button-primary" (click)="onAddIncident()" [disabled]="formGroup.invalid">
      Add incident
    </button>
  </div>
</app-base-modal>
